import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useState } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import { H2 } from 'UIComponents/elements/headings';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CreateTopicDialog = ({
  headerText,
  messageText,
  onSave,
  onClose
}) => {
  const [phrase, setPhrase] = useState('');
  const handleChange = event => {
    setPhrase(event.target.value.trim());
  };
  const isValid = phrase !== '';
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs(UIModal, {
      "data-test-id": "topic-editor-create-topic-modal",
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: onClose
        }), /*#__PURE__*/_jsx(H2, {
          children: headerText
        })]
      }), /*#__PURE__*/_jsxs(UIDialogBody, {
        children: [messageText, /*#__PURE__*/_jsx(UIFormControl, {
          label: headerText,
          children: /*#__PURE__*/_jsx(UITextInput, {
            placeholder: I18n.text('xray-recommendation-lib.seo.topicEditor.createTopicModal.placeholder'),
            onChange: handleChange
          })
        })]
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          disabled: !isValid,
          use: "primary",
          onClick: () => onSave({
            phrase
          }),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "xray-recommendation-lib.seo.topicEditor.createTopicModal.actions.save"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: onClose,
          use: "secondary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "xray-recommendation-lib.seo.topicEditor.createTopicModal.actions.close"
          })
        })]
      })]
    })
  });
};